import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { Caption } from 'blaze-ui/icons'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'

export const Instagram = (props: LevelProps) => {
  const isVirtualMarketer = useCurrentWorkspace()?.is_virtual_marketer

  return (
    <LevelPage
      {...props}
      imgScale={0.45}
      cards={LEVEL_CARDS.L3.INSTAGRAM.filter(
        (card) => !isVirtualMarketer || card.wizard !== GenerationType.InstagramPlanning,
      )}
      alternativeAction={{
        altWizard: ChannelType.InstagramCaptions,
        label: 'I just need a caption',
        icon: Caption,
      }}
    />
  )
}
